import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PortalLayout from './layouts/PortalLayout';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Logout from './pages/Logout';
import AzureSetup from './pages/AzureSetup';
import Welcome from './pages/Welcome';
import BillingSetup from './pages/BillingSetup';
import Callback from './pages/Callback';
import LoginCallback from './pages/LoginCallback';
import Profile from './pages/Profile';
import Chat from './pages/Chat';
import NiwtDirectory from './pages/NiwtDirectory';
import Billing from './pages/Billing';
import Integrations from './pages/Integrations';
import ComplianceReport from './pages/ComplianceReport';
import EmployeeSelection from './pages/EmployeeSelection';
import IngestionStatus from './pages/IngestionStatus';
import Help from './pages/Help';
import Dashboard from './features/dashboard/Dashboard';
import { getHomeRoute } from './utils/homeRoute';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/login-callback" element={<LoginCallback />} />

          {/* Semi-protected routes - requires auth but for initial setup */}
          <Route
            path="/welcome"
            element={
              <ProtectedRoute>
                <Welcome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing/setup"
            element={
              <ProtectedRoute>
                <BillingSetup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/azure-setup"
            element={
              <ProtectedRoute>
                <AzureSetup />
              </ProtectedRoute>
            }
          />

          {/* Protected routes - wrapped in PortalLayout */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <PortalLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to={getHomeRoute()} replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="chat" element={<Chat />} />
            <Route path="directory" element={<NiwtDirectory />} />
            <Route path="billing" element={<Billing />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="employee-selection" element={<EmployeeSelection />} />
            <Route path="ingestion-status" element={<IngestionStatus />} />
            <Route path="compliance-report" element={<ComplianceReport />} />
            <Route path="profile" element={<Profile />} />
            <Route path="help" element={<Help />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
